import { useState } from "react";
import {
  LegalDocumentDialog,
  type LegalDocumentKind
} from "@/components/legal/LegalDocumentDialog";

export function useLegalDocumentDialog() {
  const [documentKind, setDocumentKind] = useState<LegalDocumentKind | null>(null);

  return {
    openLegalDocument: setDocumentKind,
    legalDocumentDialog: (
      <LegalDocumentDialog documentKind={documentKind} onClose={() => setDocumentKind(null)} />
    )
  };
}
